export default "__VITE_ASSET__bbc5d985__"